<template>
  <table class="top-sites-table">
    <thead>
      <tr>
        <translate tag="th">Site name</translate>
        <translate tag="th">Region</translate>
        <translate tag="th">Pitch types</translate>
        <translate tag="th" class="center-align">Rating</translate>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(site, index) in data"
        :key="index"
        :onclick="`window.open('${$puLocalePath({ path: site.url })}', '_blank')`"
      >
        <td>
          <nuxt-link :to="$puLocalePath({ path: site.url })" target="_blank">{{
            site.name
          }}</nuxt-link>
        </td>
        <td>{{ site.region }}</td>
        <td>
          <site-types :show-title="false" :site-types="site.pitchTypes" />
        </td>
        <td class="center-align">
          <pu-rating-bubble :rating="site.rating" :rate-count="100" />
          <translate :tt="{ count: site.reviewsCount }" class="reviews-meta">
            {count} reviews(s)
          </translate>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import type { SiteType } from '~/apps/campsite-details/types.ts'

interface ReviewAwardsTopSitesData {
  name: string
  region: string
  url: string
  rating: number
  reviewsCount: number
  pitchTypes: SiteType[]
}

@Component({})
class ReviewAwardsTopSites extends Vue {
  @Prop()
  data: ReviewAwardsTopSitesData[]
}

export default toNative(ReviewAwardsTopSites)
</script>
